import { modifier } from 'ember-modifier';
import { later, scheduleOnce } from '@ember/runloop';
import mockWindow from 'ember-window-mock';

export const FRAGMENT_QUERY = 'fragment';

const scheduleScrollTo = (element: HTMLElement) => () => {
  later(() => {
    let offset = element?.offsetTop ?? 0;
    mockWindow.scrollTo(document.body.scrollLeft, offset);
  }, 200);
};

export default modifier((element: HTMLElement, [fragment]: string[]) => {
  if (!mockWindow.location.search.includes(FRAGMENT_QUERY)) {
    return;
  }

  let [, activeFragment] =
    mockWindow.location.search
      .replace('?', '')
      .split('&')
      .find((param: string) => param.includes('fragment'))
      ?.split('=') ?? [];

  if (activeFragment === fragment) {
    // Ensure this runs after the app has rendered, then scroll to the element
    // after a tick, presumably so that the browser can finish painting.
    scheduleOnce('afterRender', this, scheduleScrollTo(element));
  }
});
